module.exports = ":host,\n.ssrs-report-viewer {\n  width: 100%;\n  height: 100%; }\n\n.report-viewer-iframe {\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  border: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/components/ssrs-report-viewer.component.scss
// module id = ./src/app/report/components/ssrs-report-viewer.component.scss
// module chunks = main